import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

function UploadInitiatedModal({ modalIsOpen, modelsCount, closeModal }) {
  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={() => closeModal()}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--batch-upload-initiated">
          <div className="l-inner-large">
            <div className="overlay-modal__header">
              <Icon type={['fal', 'check-circle']} notSpaced />
              <div className="header-text">Upload started!</div>
            </div>

            <div className="overlay-modal__content">
              <p className="content__big-text u-text-center">
                Congrats! Your <span className="text-semibold">{modelsCount}</span> models are being uploaded now.
              </p>
              <p className="text-default">
                <span className="text-semibold">Each model will appear in your My Products section</span> as soon as it
                is uploaded. You will then be able to edit and publish them on the marketplace. You can see your upload
                progress in the status bar at the bottom of this page.
              </p>
              <div className="content__attention-text">
                <div className="attention-text__icon">
                  <Icon type={['far', 'info-circle']} />
                </div>
                <p className="attention-text__text u-mb0">
                  Leave this browser window open throughout the upload process, otherwise the upload will be cancelled!
                </p>
              </div>
              <div className="u-text-center">
                <button className="btn btn-fat btn-primary" onClick={() => closeModal()}>Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

UploadInitiatedModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  modelsCount: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default UploadInitiatedModal
